<div class="deploy-sizing mb-24 deploy-page">
    <div class="pt-12 ml-34 mr-12">
        <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    </div>
    <div class="pl-32 pt-16 pb-12 mt--14 header-section">
        <div class="flex flex-row flex-auto justify-between items-start">
            <div class="flex flex-row">
            <div class="flex flex-row items-start mt-4">
                <mat-icon (click)="goBack()" class="icon cursor-pointer" svgIcon="arrow_back"></mat-icon>
            </div>
            <div class="flex flex-col ml-12">
                <div class="mat-subtitle-1 fw-600 mb-0">{{'INSTANCE_SUMMARY.DEPLOY' | transloco}}</div>
                <div class="flex flex-row mt-12 header-meta">
                    <div class="mr-12">{{'BLUEPRINT_SUMMARY.SUMMARY.SERVICE_DEFINITION' | transloco}}
                        <span *ngIf="!isLoading; else loader">{{ blueprint?.name}}</span>
                    </div>
                    <span class="vertical-divider" [class.loading-divider]="isLoading"></span>
                    <div class="pl-12 mr-12">
                        {{'BLUEPRINT_SUMMARY.SUMMARY.ENVIRONMENT' | transloco}}
                        <span *ngIf="!isLoading; else loader">{{ instance?.name }}</span>
                    </div>
                    <span class="vertical-divider" [class.loading-divider]="isLoading"></span>
                    <div class="pl-12">
                        {{'SIZING.SIZING' | transloco}}
                        <span *ngIf="!isLoading; else loader">{{'SIZING.SIZE' | transloco}}</span>
                    </div>
                </div>
                <ng-template #loader>
                    <span class="skeleton-loader">
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '22px', width: '120px' }"></ngx-skeleton-loader>
          </span>
                </ng-template>
            </div>
            </div>
            <div *ngIf="showWatchTutorial" class="flex flex-row items-center cursor-pointer watch-tutorial-btn mr-16" (click)="openProvisionTutorial()">
                <mat-icon svgIcon="play_circle" class="icon-md mr-6"></mat-icon>
                <span class="fw-500 fs-14">{{'SIZING_VIDEO_TUTORIAL.WATCH_TUTORIAL' | transloco}}</span>
            </div>
        </div>
    </div>
    <div class="deploy-stepper-row">
        <div class="step-card">
            <app-initialized [class.active]="isActive(DeployStep.INITIALIZED)" [class.completed]="isCompleted(DeployStep.INITIALIZED)" [createdDate]="instance?.dateCreated" [createdBy]="instance?.createdBy"></app-initialized>
        </div>
        <span class="step-arrow">
  <mat-icon svgIcon="double_right_arrow"></mat-icon>
</span>
        <div class="step-card">
            <app-sizing [active]="isActive(DeployStep.SIZING)" [completed]="isCompleted(DeployStep.SIZING)" [failed]="isFailed(DeployStep.SIZING)" [sizingStatus]="sizingStatus" [createdDate]="sizingCreatedDate" [createdBy]="sizingCreatedBy"></app-sizing>
        </div>
        <span class="step-arrow-configure" [class.arrow-disabled]="sizingStatus !== SizingStatus.COMPLETED" [class.arrow-active]="sizingStatus === SizingStatus.IN_PROGRESS">
  <mat-icon svgIcon="double_right_arrow"></mat-icon>
</span>
        <div class="step-card">
            <app-configure [active]="isActive(DeployStep.CONFIGURE)" [completed]="isCompleted(DeployStep.CONFIGURE)" [sizingStatus]="sizingStatus"></app-configure>
        </div>
    </div>
    <div *ngIf="isSizingCreated && currentStep !== DeployStep.CONFIGURE" class="sizing-doc-banner">
            <span class="label">Name: {{ sizingDocumentName }}</span>
            <span class="separator">|</span>
            <span class="label">Created: {{ sizingCreatedDate | date : 'MMM dd, yyyy' }}</span>
            <span class="separator">|</span>
            <mat-icon class="account-circle" svgIcon="account_circle_filled" matTooltipClass="tooltip-inner right" [matTooltip]="sizingCreatedBy" [matTooltipPosition]="'right'"></mat-icon>
    </div>
    <div class="deploy-content" *ngIf="isActive(DeployStep.INITIALIZED)">
        <div class="details-row">
            <div class="detail-item">
                <div class="label-row">
                    <label class="fs-12 fw-700">{{'INSTANCE_SUMMARY.INSTANCE_NAME' | transloco | uppercase}}</label>
                    <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="tooltip-inner right" [matTooltip]="'INSTANCE_SUMMARY.INSTANCE_NAME' | transloco" [matTooltipPosition]="'right'"></mat-icon>
                </div>
                <input type="text" placeholder="{{'INSTANCE_SUMMARY.INSTANCE_NAME' | transloco}}" [value]="formatDisplay(instance?.name)" disabled />
            </div>

            <div class="detail-item">
                <div class="label-row">
                    <label class="fs-12 fw-700">{{'TENANT_LAYOUT.SERVICE_DEFINITION.SERVICE_DEFINITION_VERSION' | transloco | uppercase}}</label>
                    <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="tooltip-inner right" [matTooltip]="'TENANT_LAYOUT.SERVICE_DEFINITION.SERVICE_DEFINITION_VERSION' | transloco" [matTooltipPosition]="'right'"></mat-icon>
                </div>
                <input type="text" placeholder="{{'TENANT_LAYOUT.SERVICE_DEFINITION.SERVICE_DEFINITION_VERSION' | transloco}}" [value]="formatDisplay(solution?.version)" disabled />
            </div>

            <div class="detail-item">
                <div class="label-row">
                    <label class="fs-12 fw-700">{{'INSTANCE_DETAILS.DEPLOYMENT_CLASS' | transloco | uppercase}}</label>
                    <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="tooltip-inner right" [matTooltip]="'INSTANCE_DETAILS.DEPLOYMENT_CLASS' | transloco" [matTooltipPosition]="'right'"></mat-icon>
                </div>
                <input type="text" placeholder="{{'INSTANCE_DETAILS.DEPLOYMENT_CLASS' | transloco}}" [value]="formatDisplay(instance?.deploymentClass)" disabled />
            </div>

            <div class="detail-item">
                <div class="label-row">
                    <label class="fs-12 fw-700">{{'INSTANCE_DETAILS.DATA_ZONE' | transloco | uppercase}}</label>
                    <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="tooltip-inner right" [matTooltip]="'INSTANCE_DETAILS.DATA_ZONE' | transloco" [matTooltipPosition]="'right'"></mat-icon>
                </div>
                <input type="text" placeholder="{{'INSTANCE_DETAILS.DATA_ZONE' | transloco}}" [value]="formatDisplay(instance?.dataZone)" disabled />
            </div>

            <div class="detail-item">
                <div class="label-row">
                    <label class="fs-12 fw-700">{{'INSTANCE_DETAILS.RELEASE_VERSION' | transloco | uppercase}}</label>
                    <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="tooltip-inner right" [matTooltip]="'INSTANCE_DETAILS.RELEASE_VERSION' | transloco" [matTooltipPosition]="'right'"></mat-icon>
                </div>
                <input type="text" placeholder="{{'INSTANCE_DETAILS.RELEASE_VERSION' | transloco}}" [value]="formatDisplay(solution?.releaseVersion)" disabled />
            </div>

            <div class="detail-item">
                <div class="label-row">
                    <label class="fs-12 fw-700">{{'BLUEPRINT_SUMMARY.REQUEST_ORIGNATION' | transloco | uppercase}}</label>
                    <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="tooltip-inner right" [matTooltip]="'BLUEPRINT_SUMMARY.REQUEST_ORIGNATION' | transloco" [matTooltipPosition]="'right'"></mat-icon>
                </div>
                <input type="text" placeholder="{{'BLUEPRINT_SUMMARY.REQUEST_ORIGNATION' | transloco}}" [value]="formatDisplay(instance?.requestOrigination)" disabled />
            </div>

            <div class="detail-item">
                <div class="label-row">
                    <label class="fs-12 fw-700">{{'BLUEPRINT_SUMMARY.CONTRACT_END_DATE' | transloco | uppercase}}</label>
                    <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="tooltip-inner right" [matTooltip]="'BLUEPRINT_SUMMARY.CONTRACT_END_DATE' | transloco" [matTooltipPosition]="'right'"></mat-icon>
                </div>
                <input type="text" placeholder="{{'BLUEPRINT_SUMMARY.CONTRACT_END_DATE' | transloco}}" [value]="formatDisplay(formattedContractEndDate)" disabled />
            </div>

            <div class="detail-item">
                <div class="label-row">
                    <label class="fs-12 fw-700">{{'INSTANCE_DETAILS.ENVIRONMENT' | transloco | uppercase}}</label>
                    <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="tooltip-inner right" [matTooltip]="'INSTANCE_DETAILS.ENVIRONMENT' | transloco" [matTooltipPosition]="'right'"></mat-icon>
                </div>
                <input type="text" placeholder="{{'INSTANCE_DETAILS.ENVIRONMENT' | transloco}}" [value]="'DEVELOPMENT'" disabled />
            </div>

            <div class="detail-item">
                <div class="label-row">
                    <label class="fs-12 fw-700">{{'INSTANCE_SUMMARY.SERVICE' | transloco | uppercase}}</label>
                    <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="tooltip-inner right" [matTooltip]="'INSTANCE_SUMMARY.SERVICE' | transloco" [matTooltipPosition]="'right'"></mat-icon>
                </div>
                <input type="text" placeholder="{{'INSTANCE_SUMMARY.SERVICE' | transloco}}" [value]="formatDisplay(solution?.name)" disabled />
            </div>

            <div class="detail-item">
                <div class="label-row">
                    <label class="fs-12 fw-700">{{'INSTANCE_DETAILS.REGION' | transloco | uppercase}}</label>
                    <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="tooltip-inner right" [matTooltip]="'INSTANCE_DETAILS.REGION' | transloco" [matTooltipPosition]="'right'"></mat-icon>
                </div>
                <input type="text" placeholder="{{'INSTANCE_DETAILS.REGION' | transloco}}" [value]="formatDisplay(instance?.regionPair)" disabled />
            </div>
        </div>
    </div>
    <div class="sizing-root" *ngIf="isActive(DeployStep.SIZING)">

        <div class="sizing-toolbar">
            <div class="left">
                <div class="tabs">
                    <span class="tab" [class.active]="currentView === SizingViewMode.FORM" (click)="switchView(SizingViewMode.FORM)">{{'CUSTOM_IMAGES.FORM' | transloco}}</span>
                    <span class="vertical-divider"></span>
                    <span class="tab" [class.active]="currentView === SizingViewMode.JSON" (click)="switchView(SizingViewMode.JSON)">{{'CUSTOM_IMAGES.JSON' | transloco}}</span>
                </div>

                <div class="search-box">
                    <input class="fs-14 fw-500" type="text" placeholder="Search" [(ngModel)]="searchTerm" (input)="applySearch()" />
                    <mat-icon class="icon-search" svgIcon="search"></mat-icon>
                </div>
                 @if (templateResponse) {
                    <button class="download-btn" (click)="downloadJson()">
                        <mat-icon svgIcon="file_download"></mat-icon>
                        {{'CUSTOM_IMAGES.DOWNLOAD_JSON' | transloco}}
                    </button>
                }
            </div>
        </div>
    <div *ngIf="currentView === SizingViewMode.FORM">
        <div class="sizing-body">
            @if (!templateResponse && ((sizingCards?.length === 0 && searchTerm?.trim()) || !searchTerm)) {
                <div class="no-results">
                    <img src="assets/images/no-template.png" alt="No Results" />
                    <div class="no-results-text">{{'SIZING.NO_RECORD' | transloco }}</div>
                </div>
            }  @else {
                @if (sizingCards?.length === 0 && searchTerm?.trim()) {
                    <div class="no-results">
                        <img src="assets/images/no_result.svg" alt="No Results" />
                        <div class="no-results-text">{{'COMMON_MESSAGE.NO_RESULTS_FOUND' | transloco }}</div>
                    </div>
                } @else {
            <div *ngFor="let card of sizingCards" class="sizing-card">

                <div class="card-header floating">
                    <span class="fs-10 fw-700 pill pill-transact">{{ card.title }}</span>
                    <span class="fs-10 fw-700 pill pill-database">{{ card.component }}</span>
                </div>

                <div *ngFor="let section of card.sections; let last = last" class="section">

                    <div class="section-title fs-14 fw-700">
                        {{ section.sectionTitle }}
                    </div>

                    <div class="metrics-row">
                        <div *ngFor="let metric of section.metrics" class="metric">
                            {{ metric.label }}: {{ metric.value }}
                        </div>
                    </div>

                    <div *ngIf="!last" class="divider-line"></div>
                </div>
            </div>
        }
        @if(!validSchema && errorsWithComponent && !searchTerm) {
            <div class="no-results">
                <div class="flex flex-col items-center">
                    <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
                    <div class="mat-subtitle-2 fs-16 fw-600 mt-16">{{'SIZING.VALIDATE_MESSAGE1' | transloco }}</div>
                    <div class="mat-subtitle-2 fs-16 fw-600 mt-16">{{'SIZING.VALIDATE_MESSAGE2' | transloco }}</div>
                    <span class="agent-link mat-body-2 mt-24" (click)="showErrorDialog(false)">{{'SIZING.VIEW_DETAILS'| transloco}}</span>
                </div>
            </div>
        }
        @if(retrySizing) {
        <div class="no-results">
                <div class="flex flex-col items-center">
                    <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
                    <div class="mat-subtitle-2 fs-16 fw-600 mt-16 mr-8">{{'SIZING.SIZING_VALIDATION' | transloco }}</div>
                    <div class="flex flex-row justify-center items-center mt-24">
                        <button class="white mr-20 report-letter-spacing" type="button" (click)="startSizingProcess()"> {{ 'ERROR_DIALOG.RETRY' | transloco }} </button>
                        <button class="error-report-bg-color accent report-letter-spacing" type="button" (click)="openContactForm()"> {{ 'ERROR_DIALOG.REPORT' | transloco }} </button>
                     </div>
                </div>
            </div>
        }
        }
        </div>
    </div>
    <div *ngIf="currentView === SizingViewMode.JSON" class="json-view">
        <div class="editor-container">
            <div><ngx-monaco-editor *ngIf="!isJsonLoading" [options]="editorOptions" [model]="jsonInput" class="editor"></ngx-monaco-editor></div>
        </div>
        <div *ngIf="isJsonLoading" class="editor-loader">
            <mat-spinner diameter="18"></mat-spinner>
        </div>
    </div>
    </div>
    <div class="deploy-content" *ngIf="currentStep === DeployStep.CONFIGURE">
        <app-resource-configuration-content [instancesId]="instanceId" [blueprintId]="activatedRoute.snapshot.params.blueprintId">
        </app-resource-configuration-content>
    </div>

    <div *ngIf="currentStep !== DeployStep.CONFIGURE && !isGlobalLoading || retrySizing" class="deploy-footer">
        <div class="footer-divider"></div>

        <div class="footer-actions">
            <button class="flex justify-items-center items-center cancel-btn pr-16 pl-16 pt-8 pb-8" (click)="goBack()">{{ 'BUTTONS.CANCEL' | transloco }}</button>
            <button *ngIf="currentStep === DeployStep.SIZING" [disabled]="sizingStatus === SizingStatus.IN_PROGRESS || isSubmitClicked || retrySizing" class="flex justify-items-center spacing items-center mossgreen primary-fg pr-16 pl-16 pt-8 pb-8" (click)="validSchema ? onSizingAction() :''" [ngClass]="{'disabled': !validSchema}">
                {{ sizingStatus === SizingStatus.NOT_STARTED || sizingStatus === SizingStatus.FAILED  ? 'Submit' : 'Next' }}
            </button>
            <button *ngIf="!isActive(DeployStep.SIZING)" [disabled]="isLoading" class="flex justify-items-center spacing items-center mossgreen primary-fg pr-16 pl-16 pt-8 pb-8" (click)="next()" type="button">{{ 'BUTTONS.NEXT' | transloco }}</button>
        </div>
    </div>
</div>